export const SESSION_STORAGE_KEYS = {
  SOURCE_ENV_KEY: 'iframe_source_env'
}
